import { GET_INQUIRIES } from "constants/inquiries";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_INQUIRIES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
